module.exports = __webpack_public_path__ + "static/media/attribute_atkrate.a9a8b893.png";